import React, { useContext, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
import Modal from "ui-components/Modal";
import ServiceConfiguratorAlertTCS from "../ServiceConfiguratorAlertTCS";
import ServiceConfiguratorExpressionMarker from "../ServiceConfiguratorExpressionMarker";
import ServiceConfiguratorBlockExpressionConfigurator from "../ServiceConfiguratorBlockExpressionConfigurator";
import Toggle from "ui-components/Toggle";
import Button from "ui-components/Button";
import useCountryAxiosInstance from "../../hooks/useCountryAxiosInstance";
import { NotificationsContext } from "@ui-components/Notifications";
import { isValidRecursiveQuestion } from "../../utils/blockValidation";

export const TCSServiceModal = ({
  isTCSLoading,
  setIsTCSLoading,
  TCSMetadata_,
  setTCSMetadata_,
  setOpenTCSBlock,
  service,
  data,
  setService,
}) => {
  const { push } = useContext(NotificationsContext);
  const countryApiRequest = useCountryAxiosInstance();
  const intl = useIntl();
  const [showTCSDependencies, setShowTCSDependencies] = useState(null);

  return (
    <Modal
      onExit={() => {
        // RESET metadata_ of it's original value
        setTCSMetadata_(service?.metadata_?.TCS);
        setOpenTCSBlock(false);
        setShowTCSDependencies(false);
      }}
      submitting={isTCSLoading}
    >
      <div>
        <h2 className="text-xl">
          <FormattedMessage id="setup_TCS" defaultMessage="Configura TCS" />
        </h2>
        <p className="text-base mb-4">
          <FormattedMessage
            id="setup_TCS_description"
            defaultMessage="Configura il supporto TCS per il configuratore"
          />
        </p>
        {showTCSDependencies ? (
          <ServiceConfiguratorBlockExpressionConfigurator
            setShowDependencies={setShowTCSDependencies}
            fullExpression={TCSMetadata_?.dependencies}
            newData={TCSMetadata_}
            setNewData={(TCS) => {
              setTCSMetadata_({ ...TCS });
            }}
            questions={data.filter(
              (d) => d.type === "question" && d.input_type
            )}
            recursiveQuestions={data.filter((d) => isValidRecursiveQuestion(d))}
            outputs={data.filter(
              (d) =>
                d.type === "output" &&
                ["calculation", "json_output_value"].includes(d.output_type)
            )}
            data={data}
            type={"dependencies"}
          />
        ) : (
          <>
            <ServiceConfiguratorAlertTCS
              metadata_={TCSMetadata_}
              setMetadata={setTCSMetadata_}
            />
            <ServiceConfiguratorExpressionMarker
              onClick={() => {
                setShowTCSDependencies("dependencies");
              }}
              title="Dependencies"
              setted={TCSMetadata_?.dependencies?.length}
            />
            <Toggle
              label={intl.formatMessage({ id: "active" })}
              checked={TCSMetadata_.active}
              onChange={() =>
                setTCSMetadata_({
                  ...TCSMetadata_,
                  active: !TCSMetadata_.active,
                })
              }
            />

            <div className="flex w-full justify-between mt-8">
              <Button
                styleType="danger"
                disabled={!service.metadata_?.TCS}
                onClick={async () => {
                  // DELETE
                  setIsTCSLoading(true);
                  let _service = { ...service };
                  try {
                    delete _service.metadata_.TCS;
                    await countryApiRequest.put(
                      `/services/${service.id}`,
                      _service
                    );
                    push({
                      title: intl.formatMessage({ id: "delete" }),
                      type: "success",
                    });
                  } catch (error) {
                    push({
                      title: intl.formatMessage({ id: "server_error" }),
                      type: "error",
                    });
                  }
                  setOpenTCSBlock(false);
                  setService(_service);
                  setTCSMetadata_(service?.metadata_?.TCS);
                  setIsTCSLoading(false);
                }}
              >
                {intl.formatMessage({ id: "delete" })}
              </Button>
              <Button
                onClick={async () => {
                  // PUT of the service in the database
                  // UPDATE PUT
                  // TO CHECK
                  setIsTCSLoading(true);
                  let _service = { ...service };
                  try {
                    _service.metadata_.TCS = TCSMetadata_;
                    await countryApiRequest.put(
                      `/services/${service.id}`,
                      _service
                    );
                    push({
                      title: intl.formatMessage({ id: "save" }),
                      type: "success",
                    });
                  } catch (error) {
                    push({
                      title: intl.formatMessage({ id: "server_error" }),
                      type: "error",
                    });
                  }
                  setOpenTCSBlock(false);
                  setService(_service);
                  setIsTCSLoading(false);
                }}
              >
                {intl.formatMessage({ id: "save" })}
              </Button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
